export default "__VITE_ASSET__Ci79Nv$r__"